import React, { useEffect, useState } from 'react';
import OrderCard from "./OrderCard";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { fetch_my_orders_v2 } from '../apiservices/ApiService';

const OrdersDetailPage = () => {

    const [orders, setOrders] = useState([]);
    const [pageId, setPageId] = useState(1); // Keep track of the current page
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true); // To check if there are more pages
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);  // This will navigate to the previous page
    };


    const fetchOrders = async() => {
        if (isLoading || !hasMore) return; // Prevent multiple requests or if no more data
        setIsLoading(true);
        console.error("fetch_my_orders_v2 : ");
        const response = await fetch_my_orders_v2({pageId:pageId});
    
        console.error("fetch_my_orders_v2 : ", response);
    
        if (response.code === 200 && response.data != null) {
            const newOrders = response.data.latest || [];
            setOrders((prevOrders) => [...prevOrders, ...newOrders]);
            setHasMore(newOrders.length > 0); // If no new orders, stop further fetching
        }

        setIsLoading(false);
    };

    // Fetch the first page on component mount
    useEffect(() => {
        fetchOrders();
    }, [pageId]);

    // Infinite scrolling listener
    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + document.documentElement.scrollTop >=
                document.documentElement.offsetHeight - 200 && !isLoading && hasMore
            ) {
                setPageId((prevPageId) => prevPageId + 1); // Increment pageId to load the next page
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [isLoading, hasMore]);

    if (orders.length === 0 && isLoading) {
        return <div>Loading...</div>;
    }

    return (
        <div>
            {/* Header */}
            <header
                style={{
                    backgroundColor: "white",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "0.75rem 1rem",
                    }}
                >
                    <ChevronLeft onClick={goBack} style={{ width: '24px', height: '24px' }} />
                    <div
                        style={{
                            fontSize: '18px',
                            fontWeight: '400',
                            display: "flex",
                            gap: "1rem",
                            marginLeft: "10px",
                        }}
                    >
                        My Orders
                    </div>


                </div>
            </header>
            {orders.map((item, index) => (
                <OrderCard key={index} order={item} />
            ))}
            {isLoading && (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "1rem",
                        fontSize: "1rem",
                        color: "#555",
                        backgroundColor: "#f9f9f9",
                        borderRadius: "8px",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        margin: "1rem 0",
                    }}
                >
                    <div
                        style={{
                            width: "24px",
                            height: "24px",
                            border: "3px solid #e0e0e0",
                            borderTop: "3px solid #007bff",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                            marginRight: "0.5rem",
                        }}
                    ></div>
                    Loading more orders...
                    <style>
                        {`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}
                    </style>
                </div>
            )}
            {!hasMore && (
                <div
                    style={{
                        textAlign: "center",
                        padding: "1rem",
                        fontSize: "1rem",
                        color: "#888",
                        backgroundColor: "#f9f9f9",
                        borderRadius: "8px",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        margin: "1rem 0",
                    }}
                >
                    No more orders to load.
                </div>
            )}

        </div>
    );
};

export default OrdersDetailPage;
